import ThumbnailCarousel from 'components/Content/Happening/HappeningEDP/EDPInfo/EDPMedia/EDPMediaCarousel/ThumbnailCarousel/ThumbnailCarousel';

export default ThumbnailCarousel;
